export default __webpack_public_path__ + "static/media/success-logo.1bb682fe.svg";